export class RowEventArgs {
  readonly row: Record<string, any>;

  constructor(row: Record<string, any>) {
    this.row = row;
  }
}

export class SaveEventArgs extends RowEventArgs {}
